import { render } from "./test.vue?vue&type=template&id=511f2be9&scoped=true"
import script from "./test.vue?vue&type=script&lang=js"
export * from "./test.vue?vue&type=script&lang=js"

import "./test.vue?vue&type=style&index=0&id=511f2be9&scoped=true&lang=css"

import exportComponent from "D:\\登录页面\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-511f2be9"]])

export default __exports__